import { render, staticRenderFns } from "./catalog-sub-filters.vue?vue&type=template&id=4f4d7272"
import script from "./catalog-sub-filters.vue?vue&type=script&lang=js"
export * from "./catalog-sub-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogFolders: require('/var/www/components/catalog/catalog-folders.vue').default,CatalogGenerations: require('/var/www/components/catalog/catalog-generations.vue').default})
